import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Form, Formik } from 'formik'
import SearchBar from 'components/SearchBar/SearchBar'

import {
  MerchantLookupTypes,
  MerchantLookupTxSetFieldTypes,
} from 'types/merchanTxTypes'
import { MerchantLookupTxSchemas } from 'schemas/merchantTxSchemas'
import { useMerchantLookupTx as useMerchantLookupWithTraderId } from './useMerchantLookupTx'
import { useMerchantLookupTx as useMerchantLookupListOnly } from './useMerchantLookupListsTx'
const Index: React.FC<{
  setFieldValue: MerchantLookupTxSetFieldTypes
  title?: string
  placeholder?: string
  useMerchantLookupLists?: boolean
}> = ({
  setFieldValue: setFieldValueMain,
  useMerchantLookupLists = false,
}) => {
  const { traderId } = useParams()
  const [selectedMerchantId, setSelectedMerchantId] = useState<string | null>(null)
  const [selectedMerchant, setSelectedMerchant] = useState<MerchantLookupTypes | null>(null)
  const [advancedResults, setAdvancedResults] = useState<MerchantLookupTypes[]>([])
  const [isAdvancedResultsCollapsed, setIsAdvancedResultsCollapsed] = useState(false)
  const [isAdvancedSearching, setIsAdvancedSearching] = useState(false)
  const [advancedSearchError, setAdvancedSearchError] = useState('')
  const merchantLookupWithTraderId = useMerchantLookupWithTraderId(
    String(traderId),
    setFieldValueMain
  )
  const merchantLookupListOnly = useMerchantLookupListOnly(setFieldValueMain)
  const {
    initialValues,
    handleSubmitMerchantLookupTx,
    searchMerchants,
  } = useMerchantLookupLists
    ? merchantLookupListOnly
    : merchantLookupWithTraderId

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={MerchantLookupTxSchemas}
      onSubmit={handleSubmitMerchantLookupTx}
    >
      {() => (
        <Form className="flex flex-col">
          <div className="mb-5">
            <p className="font-light tracking-wide">Merchant Lookup</p>
            <div className="mt-3">
                  <SearchBar
                    isMerchantLookup
                    placeholder="Search merchants..."
                    startLoading={() => {
                      setIsAdvancedSearching(true)
                      setAdvancedSearchError('')
                      setAdvancedResults([])
                      setIsAdvancedResultsCollapsed(false)
                    }}
                    stopLoading={() => setIsAdvancedSearching(false)}
                    startFetch={async (params) => {
                      try {
                        const results = await searchMerchants(params)
                        setAdvancedResults(results)
                        setAdvancedSearchError(
                          results.length ? '' : 'No results found'
                        )
                      } catch {
                        setAdvancedResults([])
                        setAdvancedSearchError('No results found')
                      } finally {
                        setIsAdvancedSearching(false)
                      }
                    }}
                    closeSearchForm={() => {
                      // avoid typescript-eslint no-empty
                    }}
                  />
                  {selectedMerchant && (
                    <div className="mt-2 inline-flex w-fit max-w-full flex-wrap gap-x-4 gap-y-1 rounded border border-blue-200 bg-blue-50 px-2 py-1 text-sm">
                      <span className="font-medium">
                        {selectedMerchant.merchantName}
                      </span>
                    </div>
                  )}
                  {isAdvancedSearching && (
                    <div className="mt-1 text-sm text-gray-600">Loading...</div>
                  )}
                  {advancedSearchError && (
                    <div className="mt-1 text-sm text-red-600">
                      {advancedSearchError}
                    </div>
                  )}
                  {advancedResults.length > 0 && !isAdvancedResultsCollapsed && (
                    <div className="max-h-60 overflow-y-auto border rounded mt-2">
                      <table className="min-w-full text-sm">
                        <thead className="sticky top-0 bg-gray-100">
                          <tr>
                            <th className="px-2 py-1 text-left">Merchant Name</th>
                            <th className="px-2 py-1 text-left">Device Code</th>
                          </tr>
                        </thead>
                        <tbody>
                          {advancedResults.map((merchant) => (
                            <tr
                              key={`${merchant.traderId}/${merchant.deviceCode}`}
                              className={`cursor-pointer hover:bg-gray-50 ${
                                selectedMerchantId ===
                                `${merchant.traderId}/${merchant.deviceCode}`
                                  ? 'bg-blue-100'
                                  : ''
                              }`}
                              onClick={() => {
                                setFieldValueMain('storeId', merchant.traderId)
                                setFieldValueMain(
                                  'deviceCode',
                                  String(merchant.deviceCode || '')
                                )
                                setFieldValueMain('fromTraderId', merchant.traderId)
                                setSelectedMerchantId(
                                  `${merchant.traderId}/${merchant.deviceCode}`
                                )
                                setSelectedMerchant(merchant)
                                setIsAdvancedResultsCollapsed(true)
                              }}
                            >
                              <td className="px-2 py-1">{merchant.merchantName}</td>
                              <td className="px-2 py-1">{merchant.deviceCode}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default Index
